export const APP_VERSION = 'v1.00.20260514';
